<template>
  <div v-html="this.question.labelText"></div>
</template>
<script>
import QuestionMixin from "@/components/question/QuestionMixin.js";

export default {
  name: "EVDDisplayText",
  mixins: [QuestionMixin]
};
</script>
<style lang="sass" scoped></style>
